'use client'

import React from 'react'
import { Star } from 'react-feather'

export const StarRating = ({
  rating = 0,
  maxStars = 5,
  size = 24,
  className = '',
  startColor = 'text-yellow-300',
}) => {
  // Ensure rating is between 0 and maxStars
  const normalizedRating = Math.max(0, Math.min(rating, maxStars))

  const stars = []

  for (let i = 1; i <= maxStars; i++) {
    const difference = normalizedRating - (i - 1)

    if (difference >= 1) {
      // Full star
      stars.push(
        <div key={i} className="relative inline-block flex">
          <Star size={size} fill="currentColor" className={startColor} />
        </div>
      )
    } else if (difference > 0 && difference < 1) {
      // Half star
      const percentage = Math.round(difference * 100)
      stars.push(
        <div key={i} className="relative inline-block flex">
          <Star size={size} className="text-gray-300" />
          <div
            className="absolute top-0 left-0 overflow-hidden"
            style={{ width: `${percentage}%` }}
          >
            <Star size={size} fill="currentColor" className={startColor} />
          </div>
        </div>
      )
    } else {
      // Empty star
      stars.push(
        <div key={i} className="relative inline-block flex">
          <Star size={size} className="text-gray-300" />
        </div>
      )
    }
  }

  return <div className={`flex items-center gap-1 ${className}`}>{stars}</div>
}

export default StarRating
